import request from 'superagent'
import R from 'ramda'

import {likeEstate} from 'conf'

export default (userName, token, estateId, like, cb) => {
  const likeUrl = likeEstate(userName, estateId)
  if(like){
    request
      .post(likeUrl)
      .set('X-authorization', token)
      .accept('application/json')
    .end((err, res) => err ? cb(err) : cb(null, res.body))
  } else {
    request
      .del(likeUrl)
      .set('X-authorization', token)
      .accept('application/json')
    .end((err, res) => err ? cb(err) : cb(null, res.body))
  }

}



/** WEBPACK FOOTER **
 ** ./app/api/likeEstate.js
 **/